import { api } from '@/core/api/';
import utils from '@/utils/utilities.js';

const deticketsBaseURL = 'api/helpdesk';

export const getUserCases = (params, pageIndex, pageSize) =>
  api.get(`${deticketsBaseURL}/search`, {
    params: { ...params, pageIndex, pageSize },
  });

export const getUserCaseStatus = () => api.get(`${deticketsBaseURL}/status`);

export const getUserCaseModules = () =>
  api.get(`${deticketsBaseURL}/modules/eduesp`);

export const getModulesWithScreens = () =>
  api.get(`${deticketsBaseURL}/moduleswithscreens`);

export const getUserCaseScreens = (moduleId) =>
  api.get(`${deticketsBaseURL}/screens/${moduleId}`);

export const getUserCaseReferenceNumberTypes = (params) =>
  api.get(`${deticketsBaseURL}/referencenumbertypes`, { params: params });

export const getUserCaseById = (itemId) =>
  api.get(`${deticketsBaseURL}/case/${itemId}`);

export const saveUserCase = (formData) =>
  api.post(`${deticketsBaseURL}/create`, formData);

export const downloadDocument = async (documentId) => {
  api.get(`${deticketsBaseURL}/download/${documentId}`).then((response) => {
    utils.convertToBlob(response.data);
  });
};
export const deleteCase = (itemId) =>
  api.delete(`${deticketsBaseURL}/case`, {
    params: {
      itemId,
    },
  });

export const saveAdditionalInfo = (formData) =>
  api.post(`${deticketsBaseURL}/saveadditionalinformation`, formData);

export const getCommentHistory = (caseNumber) =>
  api.get(`${deticketsBaseURL}/commentshistory`, {
    params: {
      caseNumber,
    },
  });

export const getPreviousContactInformation = () =>
  api.get(`${deticketsBaseURL}/previouscontactinformation`);

export const validateReferenceNumber = (reference, referenceType) =>
  api.get(
    `${deticketsBaseURL}/validatereferencenumber?reference=${reference}&referenceType=${referenceType}`
  );

export const getCaseAttachments = (caseNumber) =>
  api.get(`${deticketsBaseURL}/caseattachments`, {
    params: {
      caseNumber,
    },
  });
